import { escaparHtml, enlaceWhatsApp } from '../componentes.js';
import { debeMostrarHorario, formatearHorario } from '../horario.js';
import { iconoLucide } from '../iconos.js';
import { iconoRedSocial } from '../redes-sociales.js';

function textoHistoria(texto) {
  return String(texto ?? '')
    .split(/\n/)
    .map((parrafo) => parrafo.trim())
    .filter(Boolean)
    .map((parrafo) => `<p>${escaparHtml(parrafo)}</p>`)
    .join('');
}

export function vistaContacto(contenedor, tienda) {
  const perfil = tienda.perfil ?? {};
  const redes = [
    ['instagram', 'Instagram', perfil.instagram],
    ['facebook', 'Facebook', perfil.facebook],
    ['tiktok', 'TikTok', perfil.tiktok],
    ['youtube', 'YouTube', perfil.youtube],
  ].filter(([, , url]) => Boolean(url));
  const horario = debeMostrarHorario(perfil) ? formatearHorario(perfil) : '';
  const historia = String(perfil.historia ?? '').trim();
  const ubicacion = [perfil.direccion, perfil.ciudad].filter(Boolean).join(', ');
  const seccionClase = historia ? ' sp-contacto--con-historia' : '';

  contenedor.innerHTML = `
    <section class="sp-page sp-contenedor sp-contacto${seccionClase}">
      <div class="sp-page__cabecera">
        <p class="sp-eyebrow">Contacto</p>
        <h1>Conversemos</h1>
        <p>${escaparHtml(perfil.descripcion ?? 'Estamos listos para ayudarte con tu compra.')}</p>
      </div>

      <div class="sp-contacto__grid">
        <div class="sp-contacto__lado-info">
          <header class="sp-contacto__lado-titulo">
            <p class="sp-eyebrow">Información</p>
            <h2>Ponte en contacto</h2>
          </header>

          <div class="sp-contacto__lista">
            ${
              perfil.whatsapp
                ? `
              <div class="sp-contacto__item sp-contacto__item--whatsapp">
                <span class="sp-contacto__item-icono">${iconoRedSocial('whatsapp')}</span>
                <div class="sp-contacto__item-cuerpo">
                  <span class="sp-contacto__item-label">WhatsApp</span>
                  <span class="sp-contacto__item-valor">${escaparHtml(perfil.whatsapp)}</span>
                </div>
              </div>`
                : ''
            }
            ${
              perfil.telefono && perfil.telefono !== perfil.whatsapp
                ? `
              <div class="sp-contacto__item">
                <span class="sp-contacto__item-icono">${iconoLucide('Phone')}</span>
                <div class="sp-contacto__item-cuerpo">
                  <span class="sp-contacto__item-label">Teléfono</span>
                  <span class="sp-contacto__item-valor">${escaparHtml(perfil.telefono)}</span>
                </div>
              </div>`
                : ''
            }
            ${
              perfil.correo
                ? `
              <div class="sp-contacto__item">
                <span class="sp-contacto__item-icono">${iconoLucide('Mail')}</span>
                <div class="sp-contacto__item-cuerpo">
                  <span class="sp-contacto__item-label">Correo electrónico</span>
                  <span class="sp-contacto__item-valor">${escaparHtml(perfil.correo)}</span>
                </div>
              </div>`
                : ''
            }
            ${
              ubicacion
                ? `
              <div class="sp-contacto__item">
                <span class="sp-contacto__item-icono">${iconoLucide('MapPin')}</span>
                <div class="sp-contacto__item-cuerpo">
                  <span class="sp-contacto__item-label">Ubicación</span>
                  <span class="sp-contacto__item-valor">${escaparHtml(ubicacion)}</span>
                </div>
              </div>`
                : ''
            }
            ${
              horario
                ? `
              <div class="sp-contacto__item">
                <span class="sp-contacto__item-icono">${iconoLucide('Clock')}</span>
                <div class="sp-contacto__item-cuerpo">
                  <span class="sp-contacto__item-label">Horario de atención</span>
                  <span class="sp-contacto__item-valor">${escaparHtml(horario)}</span>
                </div>
              </div>`
                : ''
            }
          </div>

          <a class="sp-boton sp-boton--primario sp-contacto__cta" href="${enlaceWhatsApp(tienda)}" target="_blank" rel="noreferrer">
            ${iconoRedSocial('whatsapp')}<span>Escribir por WhatsApp</span>
          </a>
        </div>

        ${
          historia
            ? `
          <div class="sp-contacto__historia">
            <header class="sp-contacto__lado-titulo">
              <p class="sp-eyebrow">Sobre nosotros</p>
              <h2>Conoce nuestra historia</h2>
            </header>
            <div class="sp-contacto__historia-cuerpo">${textoHistoria(historia)}</div>
          </div>`
            : ''
        }

        <div class="sp-contacto__redes">
          <header class="sp-contacto__redes-titulo">
            <p class="sp-eyebrow">Síguenos</p>
            <h2>Mantente conectado</h2>
            <p>Conoce nuestras novedades y síguenos donde quieras.</p>
          </header>
          ${
            redes.length
              ? `<div class="sp-redes sp-redes--iconos">${redes
                  .map(
                    ([clave, nombre, url]) =>
                      `<a href="${escaparHtml(url)}" target="_blank" rel="noreferrer" aria-label="${escaparHtml(nombre)}" title="${escaparHtml(nombre)}">${iconoRedSocial(clave, { label: nombre })}</a>`,
                  )
                  .join('')}</div>`
              : '<p class="sp-contacto__redes-vacio">Esta tienda todavía no publicó sus redes sociales.</p>'
          }
        </div>
      </div>
    </section>
  `;
}
